import {useFetchEyeExams} from './useFetchEyeExams';

/**
 * Checks if there is an eye exam exist for the provided item by ID
 */
export const useCheckIfExamExists = (id?: number) => {
    const {data, isFetching} = useFetchEyeExams();

    return {
        examStatusById: data?.data?.find?.(item => item.itemId === id)?.status || null,
        isAnyExamExist: Boolean(data?.data?.length),
        isExamByIdExist: Boolean(data?.data?.some?.(item => item.itemId === id)),
        isFetching,
    };
};
